import React from 'react'
import { Button } from 'antd'
import { DisconnectOutlined } from '@ant-design/icons'

import './index.css'
import V2EmptyState from '../../v2/components/V2EmptyState'

// No image files here on purpose: anything not already downloaded can't load
// while offline, so the icon comes bundled in the JS.
export default function NetworkError() {
  return (
    <div className='v2-scope network-error'>
      <V2EmptyState
        icon={<DisconnectOutlined />}
        title='No internet connection'
        message="Check your connection. This page will come back by itself once you're online."
        action={
          <Button
            size='large'
            className='network-error-retry'
            onClick={() => {
              if (navigator.onLine) window.location.reload()
            }}
          >
            Retry
          </Button>
        }
      />
    </div>
  )
}
